export default {
  // Instance list
  'knowledge.instance.title': 'Knowledge Base',
  'knowledge.instance.list.create': 'Create Instance',
  'knowledge.instance.list.columns.name': 'Name',
  'knowledge.instance.list.columns.description': 'Description',
  'knowledge.instance.list.columns.status': 'Status',
  'knowledge.instance.list.columns.plan': 'Plan',
  'knowledge.instance.list.columns.clusterType': 'Cluster Type',
  'knowledge.instance.list.columns.computeUnit': 'Compute Unit',
  'knowledge.instance.list.columns.region': 'Region',
  'knowledge.instance.list.columns.availabilityMode': 'Deployment Mode',
  'knowledge.instance.list.columns.flavor': 'Flavor',
  'knowledge.instance.list.columns.creationTime': 'Created',
  'knowledge.instance.list.columns.updatedAt': 'Updated',
  'knowledge.instance.list.columns.createdAt': 'Created',
  'knowledge.instance.list.columns.actions': 'Actions',
  'knowledge.instance.list.actions.manage': 'Manage',
  'knowledge.instance.list.actions.delete': 'Delete',
  'knowledge.instance.list.empty': 'No knowledge found',
  'knowledge.instance.delete.confirmTitle': 'Delete Confirmation',
  'knowledge.instance.delete.confirmContent':
    'Are you sure to delete this instance?',
  'knowledge.instance.delete.success': 'Deleted successfully',
  'knowledge.instance.delete.fail': 'Delete failed',
  // Instance detail
  'knowledge.instance.detail.kbList': 'Knowledge Base List',
  // Create instance
  'knowledge.instance.create.title': 'Create Instance',
  'knowledge.instance.create.name': 'Name',
  'knowledge.instance.create.nameRequired': 'Name is required',
  'knowledge.instance.create.namePlaceholder': 'Enter instance name',
  'knowledge.instance.create.description': 'Description',
  'knowledge.instance.create.descriptionPlaceholder': 'Enter description',
  'knowledge.instance.create.region': 'Region',
  'knowledge.instance.create.regionRequired': 'Please select region',
  'knowledge.instance.create.plan': 'Plan',
  'knowledge.instance.create.planRequired': 'Please select plan',
  'knowledge.instance.create.availabilityMode': 'Deployment Mode',
  'knowledge.instance.create.availabilityModeRequired':
    'Please select availability mode',
  'knowledge.instance.create.modeSingle': 'Single Node',
  'knowledge.instance.create.modeSingleDesc':
    'Single node deployment, suitable for development and testing',
  'knowledge.instance.create.modeMulti': 'High Availability',
  'knowledge.instance.create.modeMultiDesc':
    'Cluster deployment with high availability, suitable for production',
  'knowledge.instance.create.flavor': 'Flavor',
  'knowledge.instance.create.flavorRequired': 'Please select flavor',
  'knowledge.instance.create.planBasicDesc': 'Basic plan description',
  'knowledge.instance.create.planProductionDesc': 'Production plan description',
  'knowledge.instance.create.clusterType': 'Cluster Type',
  'knowledge.instance.create.clusterTypeRequired': 'Please select cluster type',
  'knowledge.instance.create.typeBalancedDesc': 'Balanced type description',
  'knowledge.instance.create.typeQueryDesc': 'Query type description',
  'knowledge.instance.create.typeWriteDesc': 'Write type description',
  'knowledge.instance.create.computeUnit': 'Compute Unit',
  'knowledge.instance.create.computeUnitRequired': 'Please select compute unit',
  'knowledge.instance.create.computeUnitDesc': 'Compute unit description',
  'knowledge.instance.create.storage': 'Storage',
  'knowledge.instance.create.storageRequired': 'Please select storage',
  'knowledge.instance.create.success': 'Created successfully',
  'knowledge.instance.create.fail': 'Create failed',
  // Document
  'knowledge.document.chunks': 'Chunks',
  'knowledge.document.chunkList': 'Chunk List',
  'knowledge.document.original': 'Original',
  'knowledge.document.list.title': 'Document List',
  'knowledge.document.list.columns.name': 'Name',
  'knowledge.document.list.columns.status': 'Status',
  'knowledge.document.list.columns.enabled': 'Enabled',
  'knowledge.document.list.columns.disabled': 'Disabled',
  'knowledge.document.list.columns.createdAt': 'Created At',
  'knowledge.document.list.columns.actions': 'Actions',
  'knowledge.document.list.actions.delete': 'Delete',
  'knowledge.document.delete.confirm': 'Are you sure to delete this document?',
  'knowledge.document.delete.success': 'Document deleted',
  'knowledge.document.add': 'Add Document',
  'knowledge.document.add.title': 'Add Document',
  'knowledge.document.add.file': 'File',
  'knowledge.document.add.fileRequired': 'Please select a file to upload',
  'knowledge.document.add.selectedFile': 'Selected file',
  'knowledge.document.add.success': 'Added successfully',
  // Document detail (chunk / original)
  'knowledge.document.chunk.add': 'Add Chunk',
  'knowledge.document.chunk.sort': 'Sort',
  'knowledge.document.chunk.content': 'Content',
  'knowledge.document.chunk.actions': 'Actions',
  'knowledge.document.chunk.edit': 'Edit',
  'knowledge.document.chunk.delete': 'Delete',
  'knowledge.document.chunk.deleteConfirm': 'Delete this chunk?',
  'knowledge.document.chunk.modal.editTitle': 'Edit Chunk',
  'knowledge.document.chunk.modal.addTitle': 'Add Chunk',
  'knowledge.document.chunk.modal.contentLabel': 'Content',
  'knowledge.document.chunk.modal.questionsLabel': 'Questions',
  'knowledge.document.chunk.modal.importantKeywordsLabel': 'Important Keywords',
  'knowledge.document.chunk.modal.tagPlaceholder': 'Press Enter to add',
  'knowledge.document.chunk.updated': 'Chunk updated',
  'knowledge.document.chunk.created': 'Chunk created',
  'knowledge.document.chunk.deleted': 'Chunk deleted',
  'knowledge.document.original.binaryTip':
    'This document is in binary format (e.g. Word/PDF) and cannot be previewed directly. You can download it to view.',
  'knowledge.document.original.downloadBtn': 'Download Original ({fileName})',
  'knowledge.document.original.fileLabel': 'File',
  'knowledge.document.original.loading': 'Loading or empty...',
  'knowledge.document.original.downloadStart': 'Download started',
  'knowledge.document.original.downloadFailed': 'Download failed',
  // Knowledge base
  'knowledge.kb.create': 'Create Knowledge Base',
  'knowledge.kb.create.title': 'Create Knowledge Base',
  'knowledge.kb.update.title': 'Edit Knowledge Base',
  'knowledge.kb.create.name': 'Name',
  'knowledge.kb.create.nameRequired': 'Name is required',
  'knowledge.kb.create.namePlaceholder': 'Enter knowledge name',
  'knowledge.kb.create.description': 'Description',
  'knowledge.kb.create.descriptionPlaceholder': 'Enter description',
  'knowledge.kb.create.settings': 'Settings',
  'knowledge.kb.create.embeddingModel': 'Embedding Model',
  'knowledge.kb.create.embeddingModelRequired': 'Please select embedding model',
  'knowledge.kb.create.embeddingModelPlaceholder': 'Select embedding model',
  'knowledge.kb.create.loadModelsFailed': 'Failed to load model list',
  'knowledge.kb.create.success': 'Created successfully',
  'knowledge.kb.update.success': 'Updated successfully',
  'knowledge.kb.list.columns.name': 'Name',
  'knowledge.kb.list.columns.description': 'Description',
  'knowledge.kb.list.columns.docCount': 'Documents',
  'knowledge.kb.list.columns.linkedWorkflows': 'Linked Workflows',
  'knowledge.kb.list.columns.updatedAt': 'Updated',
  'knowledge.kb.list.columns.actions': 'Actions',
  'knowledge.kb.list.actions.edit': 'Edit',
  'knowledge.kb.list.actions.delete': 'Delete',
  'knowledge.kb.list.error.fetchFailed': 'Failed to fetch knowledge list',
  'knowledge.kb.delete.confirm': 'Are you sure to delete this knowledge?',
  'knowledge.kb.delete.success': 'Deleted successfully',
  'knowledge.instance.selectPlaceholder': 'Select Instance',
  'knowledge.instance.label': 'Knowledge Instances',
  'knowledge.instance.selectRequired': 'Please select an instance first',
  'knowledge.kb.searchPlaceholder': 'Search',
  'knowledge.kb.list.columns.knowledge': 'Knowledge',
  'knowledge.kb.list.columns.documents': 'Documents',
  'knowledge.kb.list.columns.resource': 'Resource',
  'knowledge.kb.list.columns.creationTime': 'Creation Time',
  'knowledge.kb.list.meta.updated': 'Updated at {time}',
  'knowledge.kb.menu.files': 'Files',
  'knowledge.kb.menu.metadata': 'Metadata',
  'knowledge.kb.menu.retrievalTesting': 'Retrieval Testing',
  'knowledge.kb.menu.configuration': 'Configuration',
  'knowledge.kb.files.title': 'Files',
  'knowledge.kb.files.filter.allStatus': 'All Status',
  'knowledge.kb.files.sort.uploadTime': 'Sort by upload time',
  'knowledge.kb.files.searchPlaceholder': 'Search',
  'knowledge.kb.files.addFile': 'Add File',
  'knowledge.kb.files.columns.name': 'Name',
  'knowledge.kb.files.columns.status': 'Status',
  'knowledge.kb.files.columns.enabled': 'Enabled',
  'knowledge.kb.files.columns.chunkNumber': 'Chunk Number',
  'knowledge.kb.files.columns.size': 'Size',
  'knowledge.kb.files.columns.type': 'Type',
  'knowledge.kb.files.columns.updatedAt': 'Updated At',
  'knowledge.kb.files.columns.uploadTime': 'Upload Time',
  'knowledge.kb.files.columns.action': 'Action',
  'knowledge.kb.files.action.edit': 'Edit',
  'knowledge.kb.files.action.download': 'Download',
  'knowledge.kb.files.action.delete': 'Delete',
  // Metadata
  'knowledge.metadata.title': 'Metadata',
  'knowledge.metadata.add': 'Add Metadata',
  'knowledge.metadata.filter.allStatus': 'All Status',
  'knowledge.metadata.sort.uploadTime': 'Sort by upload time',
  'knowledge.metadata.searchPlaceholder': 'Search',
  'knowledge.metadata.columns.name': 'Name',
  'knowledge.metadata.columns.type': 'Type',
  'knowledge.metadata.columns.source': 'Source',
  'knowledge.metadata.columns.values': 'Values',
  'knowledge.metadata.columns.linkedChunks': 'Linked Chunks',
  'knowledge.metadata.columns.enabled': 'Enabled',
  'knowledge.metadata.columns.creationTime': 'Creation Time',
  'knowledge.metadata.columns.action': 'Action',
  'knowledge.metadata.modal.addTitle': 'Add Metadata',
  'knowledge.metadata.modal.editTitle': 'Edit Metadata',
  'knowledge.metadata.modal.name': 'Metadata Name',
  'knowledge.metadata.modal.nameRequired': 'Metadata name is required',
  'knowledge.metadata.modal.namePlaceholder': 'Enter metadata name',
  'knowledge.metadata.modal.nameTip':
    'Metadata name can only contain lowercase letters, numbers, and underscores and must start with a lowercase letter.',
  'knowledge.metadata.modal.type': 'Metadata Type',
  'knowledge.metadata.modal.typeRequired': 'Please select metadata type',
  'knowledge.metadata.delete.confirm': 'Are you sure to delete this metadata?',
  'knowledge.metadata.delete.success': 'Metadata deleted successfully',
  // Document Detail
  'knowledge.document.chunkNumber': 'Chunk Number',
  'knowledge.document.size': 'Size',
  'knowledge.document.uploadTime': 'Uploaded Time',
  'knowledge.document.sourceText': 'Source Text',
  'knowledge.document.searchChunks': 'Search',
  'knowledge.document.parseChunk': 'Parse',
  'knowledge.document.stopParseChunk': 'Stop Parsing',
  'knowledge.document.parseChunk.success': 'Parsing started',
  'knowledge.document.stopParseChunk.success': 'Parsing stopped',
  'knowledge.document.addChunk': 'Add Chunk',
  'knowledge.document.retrievalSignals': 'Retrieval Signals',
  'knowledge.document.metadata': 'Metadata',
  'knowledge.document.metadataDesc':
    'Metadata serves as a critical filter that enhances the accuracy and relevance of information retrieval. You can modify and add metadata for this Chunk here.',
  'knowledge.document.startLabeling': 'Start Labeling',
  'knowledge.document.keywords': 'Keywords',
  'knowledge.document.keywords.addTag': 'Add keyword',
  'knowledge.document.selectChunkTip': 'Select a chunk to view/edit keywords',
  'knowledge.document.selectAll': 'Select All',
  'knowledge.document.enable': 'Enable',
  'knowledge.document.disable': 'Disable',
  'knowledge.document.delete': 'Delete',
  'knowledge.document.status.unstart': 'Unstart',
  'knowledge.document.status.running': 'Running',
  'knowledge.document.status.cancel': 'Cancel',
  'knowledge.document.status.done': 'Done',
  'knowledge.document.status.fail': 'Fail',
  // Retrieval Testing
  'knowledge.retrieval.title': 'Retrieval Testing',
  'knowledge.retrieval.desc':
    'Test the hitting effect of the Knowledge based on the given query text.',
  'knowledge.retrieval.setting.title': 'Retrieval Setting',
  'knowledge.retrieval.strategy.vector': 'Vector Search',
  'knowledge.retrieval.strategy.vectorDesc':
    'Generate query embeddings and search for the text chunk most similar to its vector representation.',
  'knowledge.retrieval.strategy.fullText': 'Full-Text Search',
  'knowledge.retrieval.strategy.fullTextDesc':
    'Index all terms in the document, allowing users to search any term and retrieve relevant text chunk containing those terms.',
  'knowledge.retrieval.strategy.hybrid': 'Hybrid Search',
  'knowledge.retrieval.strategy.hybridDesc':
    "Execute full-text search and vector searches simultaneously, re-rank to select the best match for the user's query.",
  'knowledge.retrieval.setting.scoreThreshold': 'Score Threshold',
  'knowledge.retrieval.setting.rerank': 'Rerank Model',
  'knowledge.retrieval.setting.rerankPlaceholder':
    'Select a configured rerank model',
  'knowledge.retrieval.setting.weightedScore': 'Weighted Score',
  'knowledge.retrieval.setting.semantic': 'Semantic',
  'knowledge.retrieval.setting.keyword': 'Keyword',
  'knowledge.retrieval.setting.topK': 'Top K',
  'knowledge.retrieval.setting.query': 'Query Text',
  'knowledge.retrieval.setting.queryPlaceholder':
    'Please enter the query text for testing',
  'knowledge.retrieval.result.title': 'Test Result ({count})',
  'knowledge.retrieval.result.empty':
    'No test has been run yet. Results will appear here.',
  'knowledge.retrieval.result.noData': 'No results found.',
  'knowledge.retrieval.error.queryRequired': 'Please enter query text',
  'knowledge.retrieval.error.rerankRequired': 'Please select a rerank model',
  'knowledge.retrieval.error.testFailed': 'Retrieval test failed',
};
